import { KeyValue } from "@/main/models/common";
import { DomainBySystemApplicationRequest } from "@/main/models/request/templateEmailNotificationRequest";

export enum TemplateEmailNotificationTypes {
	GET_DOMAIN_BY_SYSTEM_APPLICATION = "@domainBySystemApplication/GET_DOMAIN_BY_SYSTEM_APPLICATION",
	SAVE_DOMAIN_BY_SYSTEM_APPLICATION = "@domainBySystemApplication/SAVE_DOMAIN_BY_SYSTEM_APPLICATION",
	RESET_REDUCER_DOMAIN_BY_SYSTEM_APPLICATION = "@domainBySystemApplication/RESET_REDUCER_DOMAIN_BY_SYSTEM_APPLICATION",
}

export interface TemplateEmailNotificationState {
	readonly domainBySystemApplication: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetDomainBySystemApplication {
	type: typeof TemplateEmailNotificationTypes.GET_DOMAIN_BY_SYSTEM_APPLICATION;
	payload: {
		request: DomainBySystemApplicationRequest | undefined;
	};
}

export interface SaveDomainBySystemApplication {
	type: typeof TemplateEmailNotificationTypes.SAVE_DOMAIN_BY_SYSTEM_APPLICATION;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerDomainBySystemApplication {
	type: typeof TemplateEmailNotificationTypes.RESET_REDUCER_DOMAIN_BY_SYSTEM_APPLICATION;
}

export type DomainBySystemApplicationActionTypes =
	| GetDomainBySystemApplication
	| SaveDomainBySystemApplication
	| ResetReducerDomainBySystemApplication;
